import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const ProfileBigIcon = (props: SvgProps) => (
  <Svg
    
    width={25}
    height={23}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M12.5 10.454c-1.47 0-2.724-.51-3.764-1.532-1.04-1.02-1.561-2.253-1.561-3.695 0-1.442.52-2.674 1.56-3.695C9.777.511 11.032 0 12.5 0c1.47 0 2.724.51 3.764 1.532 1.04 1.021 1.561 2.253 1.561 3.695 0 1.442-.52 2.674-1.56 3.695-1.041 1.022-2.296 1.532-3.765 1.532ZM0 23v-2.779c0-.722.21-1.392.631-2.01.42-.617.999-1.1 1.734-1.446a27.082 27.082 0 0 1 5.095-1.793 21.627 21.627 0 0 1 5.04-.606c1.672 0 3.353.202 5.044.605 1.692.403 3.39 1 5.095 1.792.734.347 1.31.83 1.73 1.448.421.617.631 1.288.631 2.01V23H0Zm1.682-1.65h21.636v-1.124c0-.406-.13-.782-.39-1.13-.26-.347-.623-.646-1.086-.899a23.306 23.306 0 0 0-4.6-1.622 20.477 20.477 0 0 0-9.497 0 22.836 22.836 0 0 0-4.57 1.622c-.474.253-.842.553-1.103.903-.26.35-.39.723-.39 1.121v1.128ZM12.5 8.803c1.002 0 1.86-.35 2.573-1.05.714-.701 1.07-1.543 1.07-2.527 0-.983-.356-1.825-1.07-2.526a3.541 3.541 0 0 0-2.573-1.05c-1.002 0-1.86.35-2.573 1.05-.714.7-1.07 1.543-1.07 2.526 0 .984.356 1.826 1.07 2.526.713.7 1.571 1.05 2.573 1.05Z"
    />
  </Svg>
)
export default ProfileBigIcon
